export interface UpdateDocumentAction {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any
    key: string
    metaData?: {
        ocr?: {
            [key: string]: any
        }
    }
}

export interface DocumentNavigateAction {
    index: number
    document: Document
}

export interface UpdateContactAction {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any
    type: string
}

export interface BulkUpdateDocumentAction {
    updates: Array<{
        key: string
        value: unknown
    }>
    metaData?: {
        ocr?: {
            [key: string]: unknown
        }
    }
}

// actions
const ACTION_PREFIX = 'document/list'

export const SHOW_LOADER_DOCUMENTS = `${ACTION_PREFIX}/SHOW_LOADER_DOCUMENTS`
export const HIDE_LOADER_DOCUMENTS = `${ACTION_PREFIX}/HIDE_LOADER_DOCUMENTS`
export const UPDATE_DOCUMENT_LIST_ITEM = `${ACTION_PREFIX}/UPDATE_DOCUMENT_LIST_ITEM`
export const UPDATE_DOCUMENT_LIST_ITEMS = `${ACTION_PREFIX}/UPDATE_DOCUMENT_LIST_ITEMS`
export const SET_DOCUMENT_PAGINATION = `${ACTION_PREFIX}/SET_DOCUMENT_PAGINATION`
export const SET_DOCUMENTS_TAGFILTER = `${ACTION_PREFIX}/SET_DOCUMENT_TAGFILTER`
export const SET_DOCUMENTS_FILTER = `${ACTION_PREFIX}/SET_DOCUMENT_FILTER`
export const SET_DOCUMENT_SEARCH_TERM = `${ACTION_PREFIX}/SET_DOCUMENT_SEARCH_TERM`
export const SET_DOCUMENT_SORT_ORDER = `${ACTION_PREFIX}/SET_DOCUMENT_SORT_ORDER`
export const REFRESH_DOCUMENTS = `${ACTION_PREFIX}/REFRESH_DOCUMENTS`
export const STOP_REFRESHING_DOCUMENTS = `${ACTION_PREFIX}/STOP_REFRESHING_DOCUMENTS`
export const ERROR_FETCHING_DOCUMENT_LIST_ITEMS = `${ACTION_PREFIX}/ERROR_FETCHING_DOCUMENT_LIST_ITEMS`
export const ERROR_DELETING_DOCUMENT_LIST_ITEM = `${ACTION_PREFIX}/ERROR_DELETING_DOCUMENT_LIST_ITEM`
export const ERROR_ADDING_TAGS = `${ACTION_PREFIX}/ERROR_ADDING_TAGS`
export const ERROR_DOWNLOADING_ZIP = `${ACTION_PREFIX}/ERROR_DOWNLOADING_ZIP`
export const ERROR_UPDATING_COLUMNS = `${ACTION_PREFIX}/ERROR_UPDATING_COLUMNS`
export const ERROR_HIDING_FILTERS = `${ACTION_PREFIX}/ERROR_HIDING_FILTERS`
export const ERROR_FETCHING_COLUMNS = `${ACTION_PREFIX}/ERROR_FETCHING_COLUMNS`
export const ERROR_SETTING_MBK_SYNC = `${ACTION_PREFIX}/ERROR_SETTING_MBK_SYNC`
export const ERROR_SETTING_IS_FAVORITE = `${ACTION_PREFIX}/ERROR_SETTING_IS_FAVORITE`
export const UPDATING_FIELDS = `${ACTION_PREFIX}/UPDATING_FIELDS`
export const SET_LIST_DISPLAY_TYPE = `${ACTION_PREFIX}/SET_LIST_DISPLAY_TYPE`
export const REMOVE_DOCUMENTS_ITEMS = `${ACTION_PREFIX}/REMOVE_DOCUMENTS_ITEMS`
export const UPDATE_TAG_FROM_DOCUMENTS_ITEMS = `${ACTION_PREFIX}/UPDATE_TAG_FROM_DOCUMENTS_ITEMS`
export const REMOVE_TAG_FROM_DOCUMENTS_ITEMS = `${ACTION_PREFIX}/REMOVE_TAG_FROM_DOCUMENTS_ITEMS`
export const RESET_UPLOADED_FILES = `${ACTION_PREFIX}/RESET_UPLOADED_FILES`
export const FETCH_COMPLETE = `${ACTION_PREFIX}/FETCH_COMPLETE`
export const QUIT_RENAMING = `${ACTION_PREFIX}/QUIT_RENAMING`
export const INIT_DELETION = `${ACTION_PREFIX}/INIT_DELETION`
export const CANCEL_DELETION = `${ACTION_PREFIX}/CANCEL_DELETION`
export const TAGS_FETCHED = `${ACTION_PREFIX}/TAGS_FETCHED`
export const ADD_TAG = `${ACTION_PREFIX}/ADD_TAG`
export const REMOVE_TAG = `${ACTION_PREFIX}/REMOVE_TAG`
export const SET_ITEM_SELECTION = `${ACTION_PREFIX}/SET_ITEM_SELECTION`
export const REVOKE_SELECTION = `${ACTION_PREFIX}/REVOKE_SELECTION`
export const SELECT_ALL = `${ACTION_PREFIX}/SELECT_ALL`
export const AG_GRID_UPDATED = `${ACTION_PREFIX}/AG_GRID_UPDATED`
export const TOGGLE_SETTINGS_MODAL = `${ACTION_PREFIX}/TOGGLE_SETTINGS_MODAL`
export const LIST_SETTINGS_UPDATED = `${ACTION_PREFIX}/LIST_SETTINGS_UPDATED`
export const FILTER_SETTINGS_UPDATED = `${ACTION_PREFIX}/FILTER_SETTINGS_UPDATED`
export const CLEAR_LIST = `${ACTION_PREFIX}/CLEAR_LIST`
export const START_UPLOAD = `${ACTION_PREFIX}/START_UPLOAD`
export const ADD_FILE_TO_UPLOAD = `${ACTION_PREFIX}/ADD_FILE_TO_UPLOAD`
export const FILE_UPLOADED = `${ACTION_PREFIX}/FILE_UPLOADED`
export const FOLDER_ADDED = `${ACTION_PREFIX}/FOLDER_ADDED`
export const EXECUTE_UPLOAD = `${ACTION_PREFIX}/EXECUTE_UPLOAD`
export const UPLOAD_COMPLETE = `${ACTION_PREFIX}/UPLOAD_COMPLETE`
export const CLOSE_UPLOAD_DRAWER = `${ACTION_PREFIX}/CLOSE_TAG_ASSIGNMENT`
export const SET_THUMBNAIL = `${ACTION_PREFIX}/SET_THUMBNAIL`
// FLAG:useDocuAi — surgical single-row patch (only dispatched on the useDocuAi path).
export const PATCH_DOCUMENT_LIST_ITEM = `${ACTION_PREFIX}/PATCH_DOCUMENT_LIST_ITEM`
// FLAG:useDocuAi — surgical single-row metaData merge (reflects analysisInProgress straight from
// the FILE:ANALYSED payload, no async refetch).
export const PATCH_DOCUMENT_LIST_ITEM_META = `${ACTION_PREFIX}/PATCH_DOCUMENT_LIST_ITEM_META`
export const DOCUMENT_SHARED = `${ACTION_PREFIX}/DOCUMENT_SHARED`
export const SET_FOLDER = `${ACTION_PREFIX}/SET_FOLDER`
export const ENABLE_FOLDERS = `${ACTION_PREFIX}/ENABLE_FOLDERS`
export const SWITCH_COLLABORATION = `${ACTION_PREFIX}/SWITCH_COLLABORATION`
export const UPDATE_COUNT = `${ACTION_PREFIX}/UPDATE_COUNT`
export const REMOVE_UPLOAD_FILE = `${ACTION_PREFIX}/REMOVE_UPLOAD_FILE`
export const REMOVE_UPLOAD_FROM_LIST = `${ACTION_PREFIX}/REMOVE_UPLOAD_FROM_LIST`
export const SET_COLLABORATORS_DATA = `${ACTION_PREFIX}/SET_COLLABORATORS_DATA `
export const OPEN_TAG_MODAL = `${ACTION_PREFIX}/OPEN_TAG_MODAL`
export const CLOSE_TAG_MODAL = `${ACTION_PREFIX}/CLOSE_TAG_MODAL`
export const DOCUMENT_FOLDER_TREE = `${ACTION_PREFIX}/DOCUMENT_FOLDER_TREE`
export const START_DOWNLOADING_ZIP = `${ACTION_PREFIX}/START_DOWNLOADING_ZIP`
export const SUCCESS_DOWNLOADING_ZIP = `${ACTION_PREFIX}/SUCCESS_DOWNLOADING_ZIP`
export const CLOSE_EDIT_DRAWER = `${ACTION_PREFIX}/CLOSE_EDIT_DRAWER`
export const INSERT_DATA = `${ACTION_PREFIX}/INSERT_DATA`
export const SET_CLIENT_SUBSCRIPTION_EXPIRED = `${ACTION_PREFIX}/SET_CLIENT_SUBSCRIPTION_EXPIRED`
